import { useQuery, useReactiveVar } from '@apollo/client';
import { initData, useSignal } from '@tma.js/sdk-react';
import { useEffect, useState } from 'react';
import { loginData } from '../client/apollo';
import { getProfileQuery } from '../client/queries/profile';
import { changeLanguage, i18next } from './index';
import { resolveLanguage } from './resolveLanguage';

export function useLanguageSync(): boolean {
    const tgUser = useSignal(initData.user);
    const hasAuthToken = Boolean(useReactiveVar(loginData)?.value?.trim());
    const { data, loading } = useQuery(getProfileQuery, { skip: !hasAuthToken });
    const backendLanguageCode = data?.user.languageCode;
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!hasAuthToken) {
            setReady(false);
            return;
        }
        if (loading) return;

        const resolved = resolveLanguage({
            backendLanguageCode,
            telegramLanguageCode: tgUser?.language_code,
        });
        if (i18next.language === resolved) {
            setReady(true);
            return;
        }

        let cancelled = false;
        void changeLanguage(resolved).finally(() => {
            if (!cancelled) setReady(true);
        });
        return () => {
            cancelled = true;
        };
    }, [backendLanguageCode, hasAuthToken, loading, tgUser?.language_code]);

    return ready;
}
